import * as types from '../actions/actionTypes';
import initialState from './initialState';
import workflowStatus from '../workflowStatus';

export default (state = initialState.app, action) => {
    switch (action.type) {

        // image workflow actions

        case types.IMAGE_WORKFLOW_STARTED:
            return { 
                ...state, 
                imageCreation: { 
                    ...initialState.app.imageCreation, 
                    workflowStatus: workflowStatus.started 
                }
            };

        case types.IMAGE_WORKFLOW_FINISHED:
            return { 
                ...state, 
                imageCreation: { 
                    ...state.imageCreation, 
                    workflowStatus: workflowStatus.finished 
                } 
            };

        case types.IMAGE_WORKFLOW_ABANDONED:
            return { 
                ...state, 
                imageCreation: { 
                    ...initialState.app.imageCreation, 
                    workflowStatus: workflowStatus.abandoned 
                }
            };

        // clone workflow actions

        case types.CLONE_WORKFLOW_STARTED:
            return { 
                ...state, 
                cloneCreation: { 
                    ...initialState.app.cloneCreation, 
                    workflowStatus: workflowStatus.started 
                } 
            };

        case types.CLONE_WORKFLOW_FINISHED:
            return { 
                ...state, 
                cloneCreation: { 
                    ...state.cloneCreation, 
                    workflowStatus: workflowStatus.finished 
                } 
            };

        case types.CLONE_WORKFLOW_ABANDONED:
            return { 
                ...state, 
                cloneCreation: { 
                    ...initialState.app.cloneCreation, 
                    workflowStatus: workflowStatus.abandoned 
                }
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/js/reducers/appWorkflowReducer.js